import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function RateLimitPage() {
  const [searchParams] = useSearchParams();
  const retryParam = searchParams.get('retry');
  const initialSeconds = retryParam ? Math.max(0, parseInt(retryParam, 10)) : 0;
  const hasCountdown = initialSeconds > 0;
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);

  useEffect(() => {
    if (!hasCountdown) { return; }

    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          window.location.href = '/';
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [hasCountdown]);

  const minutes = Math.floor(secondsLeft / 60);
  const secs = secondsLeft % 60;
  const formatted = `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <img
          src="/logos/logo-02.svg"
          alt="OutdoorGuides"
          className="h-12 mx-auto mb-8"
        />

        <div className="mx-auto w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mb-6">
          <svg className="w-10 h-10 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-3">
          Slow down
        </h1>

        <p className="text-base text-gray-600 mb-8">
          You&apos;ve made too many requests. Please wait and try again.
        </p>

        {hasCountdown ? (
          <div className="mb-8">
            <div className="text-5xl font-mono font-bold text-gray-900 mb-2" data-testid="countdown">
              {formatted}
            </div>
            <p className="text-sm text-gray-500">
              You&apos;ll be redirected automatically
            </p>
          </div>
        ) : (
          <a
            href="/"
            className="inline-block px-8 py-3 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition font-semibold text-base mb-8"
          >
            Return to Home
          </a>
        )}

        <p className="text-sm text-gray-400">
          If this problem persists, contact{' '}
          <a href="mailto:support@outdoorguides.com" className="text-emerald-600 hover:text-emerald-700 underline">
            support@outdoorguides.com
          </a>
        </p>
      </div>
    </div>
  );
}
